import { ViewConfiguration } from '../../../grid/gridView/types';
import { ColumnDetails } from '../../../grid/types/common';
import { SelectedTargets } from '../../../targets/type';
import { Rights, Role } from '../../common/accountRoleAndPrivileges/type';
import { AccountSourceId } from '../../common/types/AccountSources';

export enum ColumnIndexes {
  FULL_NAME,
  USERNAME,
  EMAIL,
  ROLE,
  SERVICES,
  COMPANY,
  TWO_FA,
  PASSWORD_EXPIRATION,
  ACCOUNT_LOCKOUT,
  ACCESS_RULE,
  STATUS,
}

export enum ColumnKeys {
  FULL_NAME = 'fullName',
  USERNAME = 'userName',
  EMAIL = 'email',
  ROLE = 'role',
  SERVICES = 'serviceTargets',
  COMPANY = 'company',
  TWO_FA = 'twoFactorAuthentication',
  PASSWORD_EXPIRATION = 'passwordLifetime',
  ACCOUNT_LOCKOUT = 'accountLockdown',
  ACCESS_RULE = 'securityGroupRule',
  STATUS = 'active',
}

export const TWO_FA = {
  DISABLED: 0,
  ENABLED: 1,
};

export const PASSWORD_EXPIRATION = {
  DISABLED: 0,
  ENABLED: 1,
};

export const ACCOUNT_LOCKOUT = {
  DISABLED: 0,
  ENABLED: 1,
};

export enum serviceTypes {
  EPS = 1,
  SVE = 2,
  MDM = 4,
}

export const DEFAULT_PAGE_SIZE = 20;

export interface AccountsGridViewData {
  views: Array<ViewConfiguration<ColumnIndexes, ColumnKeys>>;
  allColumns: Array<ColumnDetails<ColumnIndexes, ColumnKeys>>;
  defaultViewProps: ViewConfiguration<ColumnIndexes, ColumnKeys>;
  predefinedFilterKeys: Array<ColumnKeys>;
}

export interface GetAccountsResponse {
  data: Array<AccountDataGrid>;
  total: number;
}

export interface AccountsGridGetRowsResponse {
  success: boolean;
  rawEvents?: Array<AccountDataGrid>;
}

export interface AccountDataGrid {
  _id: string;
  profile?: {
    fullName?: string;
    timezone?: string;
    language?: string;
    sessionTimeout?: number;
    landingPage?: string;
  };
  phoneNumber?: PhoneNumber;
  userName?: string;
  email?: string;
  active?: boolean;
  created?: string;
  role?: Role;
  source?: AccountSourceId;
  company: {
    id: string;
    name?: string;
  };
  twoFactorAuthentication?: {
    enabled: boolean;
  };
  passwordLifetime?: number;
  accountLockdown?: {
    enabled: boolean;
    allowance: number;
  };
  concurrentSessions?: {
    enabled: boolean;
  }
  securityGroupRule?: SecurityGroupRule;
  sourceSpecifics?: SourceSpecifics;
  serviceTargets?: SelectedTargets;
  readOnly?: boolean;
}

export interface AccountRowDataGrid {
  item: AccountDataGrid;
}

export interface SecurityGroupRule {
  id?: string;
  name?: string;
}

export interface PhoneNumber {
  countryCode?: string;
  subscriberNumber?: string;
}

export interface SourceSpecifics {
  samAccountName?: string;
  netBiosDomainName?: string;
  fullyQualifiedDomainName?: string;
  userPrincipalName?: string;
  guid?: string;
  domainGuid?: string;
  connected?: boolean;
}

export interface VisibleRole {
  companyId?: string | null;
  name?: string | null;
  type?: number | null;
  rights?: Rights;
}

export enum STATUS {
  SUSPENDED,
  ACTIVE,
  AD_INTEGRATION_REMOVED,
}

export interface FilterAvailableServiceOption {
  label: string;
  value: number;
}
